import React from 'react';
import { motion } from 'framer-motion';
import { Book } from 'lucide-react';
const solutions = ['Organizar tu negocio para vender por internet con una estrategia más clara.', 'Crear anuncios pensados para atraer consultas reales, incluso con presupuestos bajos.', 'Usar inteligencia artificial para escribir anuncios, respuestas y contenido en menos tiempo.', 'Responder mejor por WhatsApp y aumentar tus chances de cerrar ventas.', 'Entender cuánto invertir, cómo medir resultados y qué ajustar.', 'Implementar un plan concreto para empezar a moverte más rápido, incluso si arrancás desde cero.'];
export function SolutionSection() {
  return <section className="py-10 sm:py-20 px-4" data-id="element-227">
      <div className="max-w-4xl mx-auto" data-id="element-228">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-229">
          <div className="text-center mb-8 sm:mb-12" data-id="element-230">
            <div className="inline-block bg-green-800/40 p-3 rounded-full mb-4" data-id="element-231">
              <span className="text-3xl" data-id="element-232">💡</span>
            </div>
            <h2 className="text-3xl sm:text-4xl font-black text-white drop-shadow-lg uppercase" data-id="element-233">
              CON EL MÉTODO VENTA FLASH IA VAS A PODER:
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-234">
            {solutions.map((solution, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-green-900/40 p-6 rounded-2xl border border-green-600/20 hover:bg-green-900/60 transition-colors" data-id="element-235">
                <div className="w-8 h-8 bg-yellow-300/20 rounded-full shrink-0 flex items-center justify-center border border-yellow-300/40" data-id="element-236">
                  <Book className="w-4 h-4 text-yellow-300" data-id="element-237" />
                </div>
                <p className="text-lg text-white font-medium leading-snug" data-id="element-238">
                  {solution}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}